import React, { useState, useEffect } from "react";
import SideNavBar from "./SideNavBar";
import NavBarMain from "./NavBarMain";
import { useNavigate } from "react-router-dom";
import {
  COMPLIANCE_APPROVED,
  COMPLIANCE_NEW,
  COMPLIANCE_PENDING,
  COMPLIANCE_REJECTED,
  COUNTRY,
  base_url
} from "../utilities";
import axios from "axios";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import moment from "moment";
import { BusinessSettings } from "./BusinessSettings";
import Cookies from 'js-cookie';

const Kycform = (props) => {
  const [defaultvalue, setDefaultValue] = useState();
  const navigate = useNavigate();
  const [download, setDownload] = useState([]);
  const [getDocuments, setGetDocuments] = useState([])
  const [statusFlag, setStatusFlag] = useState(COMPLIANCE_NEW)
  const[preOthers,setPreOthers]=useState([]);

useEffect(() => {
  if (!Cookies.get("User_Accesstoken_Business")) {
    navigate("/");
  }
}, []);
  const currentYear = new Date().getFullYear();
  const pastYears = new Date().getFullYear() - 123;

  const startYear = pastYears;
  const endYear = currentYear;
  const years = [];

  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }
  const [masterBusinessData, setMasterBusinessData] = useState([]);
  const [businessDatauser, setBusinessdataUser] = useState([]);
  const [updatedCustomers, setUpdatedCustomers] = useState([]);
  const [rejectedCustomers, setRejectedCustomers] = useState([]);
  useEffect(() => {
    if (masterBusinessData?.top_5_customers?.length > 0) {
      setUpdatedCustomers(masterBusinessData.top_5_customers);
    }
    if (masterBusinessData?.top_5_suppliers?.length > 0) {
      setUpdatedSuppliers(masterBusinessData.top_5_suppliers);
    }
    if (masterBusinessData?.banks_list?.length > 0) {
      setUpdatedBanks(masterBusinessData.banks_list);
    }
    if (masterBusinessData?.shareholders?.length > 0) {
      setShareHolderData(masterBusinessData.shareholders);
    }
  }, [masterBusinessData]);

  useEffect(()=>{
    setDeletedDoc([]);
  },[])
  const [formData, setFormData] = useState({
    business_type: "",
    phone: '',
    country: '',
    sector: '',
    registered_address: '',
    place_of_incorporation: '',
    date_of_incorporation: '',
    trade_license_no: '',
    trade_license_expiry_date: '',
    description_of_business: '',
    beneficial_owner_with_percentage_holding: '',
    products_by_the_company: '',
    origin_of_products: '',
    import_countries_with_percentage: '',
    export_countries_with_percentage: '',
    re_export_countries_with_percentage: '',
    no_of_full_time_employees: '',
    is_pep: '',
  });


  const [updatedSuppliers, setUpdatedSuppliers] = useState([]);
  const [rejectedSuppliers, setRejectedSuppliers] = useState([]);
  const [updatedBanks, setUpdatedBanks] = useState([]);
  const [rejectedBanks, setRejectedBanks] = useState([]);
  const [rejectedFlag, setRejectedFlag] = useState(true);
  const [rejectedDetails, setRejectedDetails] = useState()
  const [mergedDownloads, setMergedDownloads] = useState([]);

  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const res = await axios.post(base_url + "business-master/get_business_data_user", {
            user_id: Cookies.get("user_id"),
          });
    
          const data = res.data.data;
    
          if (data.kyc?.length === 0 || data.kyc[0]?.status !== COMPLIANCE_APPROVED) {
            Cookies.set("kyc_status", 0, { expires: 7 });
          } else {
            Cookies.set("kyc_status", 2, { expires: 7 });
          }
    
          setBusinessdataUser(data);
    
          setTimeout(() => {
            setFormData((prev) => ({
              ...prev,
              business_type: data?.business_type,
              phone: data?.phone,
              country: data?.country === "undefined" ? '' : data?.country,
              sector:data.kyc?.[0]?.sector,
              registered_address: data.kyc?.[0]?.registered_address ?? '',
              place_of_incorporation: data.kyc?.[0]?.place_of_incorporation ?? '',
              date_of_incorporation: data.kyc?.[0]?.date_of_incorporation ?? '',
              trade_license_no: data.kyc?.[0]?.trade_license_no ?? '',
              trade_license_expiry_date: data.kyc?.[0]?.trade_license_expiry_date ?? '',
              description_of_business: data.kyc?.[0]?.description_of_business ?? '',
              beneficial_owner_with_percentage_holding: data.kyc?.[0]?.beneficial_owner_with_percentage_holding ?? '',
              products_by_the_company: data.kyc?.[0]?.products_by_the_company ?? '',
              origin_of_products: data.kyc?.[0]?.origin_of_products ?? '',
              import_countries_with_percentage: data.kyc?.[0]?.import_countries_with_percentage ?? '',
              export_countries_with_percentage: data.kyc?.[0]?.export_countries_with_percentage ?? '',
              re_export_countries_with_percentage: data.kyc?.[0]?.re_export_countries_with_percentage ?? '',
              no_of_full_time_employees: data.kyc?.[0]?.no_of_full_time_employees ?? '',
              top_5_customers: data.kyc?.[0]?.top_5_customers ?? [],
              top_5_suppliers: data.kyc?.[0]?.top_5_suppliers ?? [],
              banks_list: data.kyc?.[0]?.banks_list ?? [],
              shareholders: data.kyc?.[0]?.shareholders ?? [],
              is_pep: data.kyc?.[0]?.is_pep ?? false,
            }));
    
            if (data.kyc?.length === 0 || data.kyc[0]?.status === COMPLIANCE_REJECTED) {
              setRejectedFlag(false);
            }
    
    
            if (statusFlag === COMPLIANCE_NEW) {
              setRejectedFlag(false);
            }
          }, 500); 
    
        } catch (error) {
          console.error("Error fetching business data:", error);
        }
      };
    
      fetchData();
    
      axios
        .post(base_url + "documents-type/get_document_types")
        .then((res) => {
          const doctypes = res.data.data;
          const x = doctypes.BUSINESS_KYC_FORM_DOCS.map((element) => ({
            doc_type: element,
            is_upload: false,
            file_name: "",
          }));
          setDownload(x);
        })
        .catch((err) => {
          console.error(err);
        });
    }, [Cookies.get("user_id"), statusFlag]);
    
  let countryBusns = businessDatauser?.country;

  
  let country_code = "";
  countryBusns?.toLowerCase() === COUNTRY
  ? (country_code = "BHD")
  : (country_code = "$");
  
  
  
  const [index, setIndex] = useState(0)
  const [shareHolderData, setShareHolderData] = useState([
    { index: index, name_of_shareholder: "", designation_of_shareholder: "", nationality_of_shareholder: "", dob_of_shareholder: "", residential_country_of_shareholder: "" },
  ]);
  const [rejectedShareHolderData, setRejectedShareHolderData] = useState([
    { index: index, name_of_shareholder: "", designation_of_shareholder: "", nationality_of_shareholder: "", dob_of_shareholder: "", residential_country_of_shareholder: "" },
  ]);
  const handleInputChange = (index, columnName, value) => {
   if((businessDatauser?.kyc?.length===0) || 
   (businessDatauser?.kyc?.length>0 && statusFlag===COMPLIANCE_NEW)){
     const newData = [...shareHolderData];
     newData[index][columnName] = value;
    setShareHolderData(newData);
  setFormData((prevData)=>(
    {
      ...prevData,
    [columnName]: value,
    }
  ))}
    
   if(statusFlag===COMPLIANCE_REJECTED){ 
    
    const newData = [...rejectedShareHolderData];
    newData[index][columnName] = value;
    setRejectedShareHolderData(newData);
  }
  };

  const handleAddRow = () => {
    const newRow = { index: index + 1, name_of_shareholder: "", designation_of_shareholder: "", nationality_of_shareholder: "", dob_of_shareholder: "", residential_country_of_shareholder: "" };
    if(businessDatauser?.kyc?.length===0 || statusFlag=== COMPLIANCE_NEW){setShareHolderData([...shareHolderData, newRow]);}
    if(statusFlag===COMPLIANCE_REJECTED){setRejectedShareHolderData([...rejectedShareHolderData, newRow]);
      setShareHolderData([...shareHolderData, newRow]);
    }
    setIndex(index + 1)
  };
  const handleRemoveRow = (index) => {
    if(index!==0){if(businessDatauser?.kyc?.length===0 || statusFlag=== COMPLIANCE_NEW)
{setShareHolderData((prevData) => prevData.filter((_, i) => i !== index));}
    if(statusFlag===COMPLIANCE_REJECTED){setShareHolderData(shareHolderData.filter((_, i) => i !== index));
      setRejectedShareHolderData(rejectedShareHolderData
        .filter((_, i) => i !== index));
    }}
  };


 

const handleFieldChange = (fieldName, value) => {
  if((businessDatauser?.kyc?.length===0) || 
  (businessDatauser?.kyc?.length>0 && statusFlag===COMPLIANCE_NEW)){
  setFormData((prevData) => ({
    ...prevData,
    [fieldName]: value,
  }));}
if(statusFlag===COMPLIANCE_REJECTED)
{
  setFormData((prevData) => ({
    ...prevData,
    [fieldName]: value,
  }));
}

  if(businessDatauser?.kyc[0]?.status===COMPLIANCE_REJECTED){
  setRejectedDetails((prevData) => ({
    ...prevData,
    [fieldName]: value,
  }));}
};
  var currentDate = new Date(); 
  currentDate.setDate(currentDate.getDate() + 1);
  
  const tomorrow = currentDate.toISOString().split('T')[0];
  
   
  let rowCount = window.screen.availWidth > 1860 ? 8 : 4;

 
  const handleCustomerChange = (index, value ) => {
  if((businessDatauser?.kyc?.length===0) || 
  (businessDatauser?.kyc?.length>0)){  
   
    const customers = [...updatedCustomers];
    customers[index] = value;
    setUpdatedCustomers(customers)}
    
    if(statusFlag=== COMPLIANCE_REJECTED){ 
       
    let customers = [...rejectedCustomers];
    customers[index] = value;
     setRejectedCustomers(customers)
     setUpdatedCustomers(customers)

  }
  };

  const handleSupplierChange = (index, value) => {
    if((businessDatauser?.kyc?.length===0) || 
    (businessDatauser?.kyc?.length>0)){
      const suppliers = [...updatedSuppliers];
    suppliers[index] = value;
    setUpdatedSuppliers(suppliers)
  }
    if(statusFlag===COMPLIANCE_REJECTED){
      const suppliers = [...rejectedSuppliers];
      suppliers[index] = value;
      setRejectedSuppliers(suppliers)
      setUpdatedSuppliers(suppliers)
    }
  };
 
  const handleBankChange = (index, value) => {
   if((businessDatauser?.kyc?.length===0) || 
   (businessDatauser?.kyc?.length>0)){ 
    const banks = [...updatedBanks];
    banks[index] = value;
    setUpdatedBanks(banks)}

   if(statusFlag===COMPLIANCE_REJECTED){ const banks = [...rejectedBanks];
    banks[index] = value;
    setRejectedBanks(banks)
    setUpdatedBanks(banks)}

  };
  const[deletedDoc,setDeletedDoc]=useState([]);
const handleDeleteClick = (item) => {
  let sample_download = [...download];
  sample_download.forEach((doc) => {
    if (doc.doc_type == item.doc_type) {
      item.is_upload = false;
      doc.is_upload = false;
      doc.document_type = "";
      doc.document_url = "";
      doc.file_name = "";
    }
  });
  setDownload(sample_download);
  handleDeleteDoc(item);
};
const handleDeleteDoc=(item)=>{
  setDeletedDoc(prevItems => [...prevItems, item.document_id]);
}

const handleDeleteDocForOthers=(item)=>{
  setDeletedDoc(prevItems => [...prevItems, item.document_id]);
 }
const handleChangeDownloadForOthers = (event, file,doc) => {
  if(file instanceof File)
  {
    const fileURL = URL.createObjectURL(file);
     window.open(fileURL, '_blank');
  }
  else
  {
    if (file.document_url && typeof file.document_url === 'string') {
             window.open(file.document_url, '_blank');
          }
  }
}
const[others,setOthers]=useState([]);
const [fileArray, setFileArray] = useState([]);
  const handleChange = (event, item, index) => {
    const maxFileSize = 5242880; 
    const files = Array.from(event.target.files);
    const updatedFiles = [...fileArray, ...files];
    setFileArray(updatedFiles);
    let sample_download = [];
    if (isDataNull) sample_download = [...download];
    else sample_download = [...mergedDownloads];  
    sample_download.forEach((doc) => {
      if (doc.doc_type === item.doc_type) {
        if (item.doc_type === "Others") {  
          if (updatedFiles.length < 51) {
            const validFiles = files.filter((file) => file.size < maxFileSize);
            const invalidFiles = files.filter((file) => file.size >= maxFileSize);
            if (invalidFiles.length > 0) {
              toast.error("Some files exceed 5MB and were not uploaded.", {
                toastId: 7,
              });
            }
            doc.is_upload = true;
            doc.uploaded_files = [...(doc.uploaded_files || []), ...validFiles.map((file) => ({
              file_name: file.name,
              document_url: file,
            }))];
            validFiles.forEach((file) => {
              setOthers((prevItems) => [...prevItems, file]);
            });
          } else {
            toast.warn("Max limit of 50 files reached! Try to delete some files before uploading new files");
            setOthers(updatedFiles.slice(0,50));
            setFileArray(updatedFiles.slice(0,50))
            return;
          }
        } else {
          if (files[0]?.size < maxFileSize) {
            doc.is_upload = true;
            doc.document_type = item.doc_type;
            doc.document_url = files[0];
            doc.file_name = files[0].name;
          } else {
            toast.error("File size should be less than 5MB", {
              toastId: 7,
            });
          }
        }
      }
    });
  
    setDownload(sample_download);
  };
  useEffect(()=>{
    setOthers(preOthers);
    setFileArray(preOthers)
  },[preOthers])
  const handleDeleteClickOthers = (item) => {
    let updatedOthers;
    let updatedFilesArray;
    if (item instanceof File) {
      updatedOthers = others.filter((doc) => doc.name !== item.name);
      updatedFilesArray = fileArray.filter((doc) => doc.name !== item.name);
    } else {
      updatedOthers = others.filter((doc) => doc.document_type !== item.document_type);
    }
    setOthers(updatedOthers);
    setFileArray(updatedFilesArray);
    if(preOthers.length>0 && !(item instanceof File))
    handleDeleteDocForOthers(item);
  };

    
  useEffect(()=>{
    if (Array.isArray(getDocuments?.kyc_documents)) {
      const filteredDocs = getDocuments.kyc_documents.filter((doc) => {
        return doc.document_type.includes("Others");
      });
      setPreOthers(filteredDocs);  
    }    
    },[getDocuments]);

    useEffect(()=>{
      if (preOthers.length !== 0) {
        setMergedDownloads(prevDownloads =>
          Array.isArray(prevDownloads)
            ? prevDownloads.map(item =>
            item.doc_type === 'Others' ? { ...item, is_upload: true } : item
          ): prevDownloads
        );
      }
    },[preOthers])

 
  const handleChangeDownload = (event, item) => {
    if (item.document_url && typeof item.document_url === 'string') {
      window.open(item.document_url, '_blank');
    } if (item.document_url instanceof File) {
      const fileURL = URL.createObjectURL(item.document_url);
      window.open(fileURL, '_blank');
    }
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();


 
  let plusDisabled =shareHolderData.some((obj) => Object.values(obj).some((value) => value === ''))
const[isDataNull,setIsDataNull]=useState(false);
useEffect(() => {
 if(businessDatauser?.length>0){ if(businessDatauser?.kyc[0]?.status===COMPLIANCE_APPROVED){
   Cookies.set("kyc_status", COMPLIANCE_APPROVED, { expires: 7 })
  }}
  if(businessDatauser?.user_id){axios
  .post(
    base_url + "business-master/get_business_kyc_user",
    {user_id:businessDatauser?.user_id}
  )
  .then((res) => {
    if(res.data?.data?.length===0)
    {
      setIsDataNull(true)
    }
    let data0 = res.data.data[0] ||[]
    if(data0?.kyc_expiry_date!=null && data0?.kyc_expiry_date <= new Date().getTime()|| data0?.status === undefined){
      setStatusFlag(COMPLIANCE_NEW)
    }else{
      setStatusFlag(data0.status)
    }
setMasterBusinessData(data0)
setGetDocuments(res.data.data[1])
setRejectedCustomers(data0.top_5_customers)
setRejectedSuppliers(data0.top_5_suppliers)
setRejectedBanks(data0.banks_list)
setRejectedShareHolderData(data0?.shareholders)
 if (data0.status === COMPLIANCE_REJECTED) {
setRejectedDetails({
  business_id: data0.business_id,
  business_type: data0.business_type,
  user_id: data0.user_id,
  business_kyc_id: data0.business_kyc_id,
    phone: data0.phone,
    registered_address:data0.registered_address,
    country: data0.country,
    sector: data0.sector,
    place_of_incorporation: data0.place_of_incorporation,
    date_of_incorporation: data0.date_of_incorporation,
    trade_license_no: data0.trade_license_no,
    trade_license_expiry_date: data0.trade_license_expiry_date,
    description_of_business: data0.description_of_business,
    beneficial_owner_with_percentage_holding: data0.beneficial_owner_with_percentage_holding,
    products_by_the_company: data0.products_by_the_company,
    origin_of_products: data0.origin_of_products,
    import_countries_with_percentage: data0.import_countries_with_percentage,
    export_countries_with_percentage: data0.export_countries_with_percentage,
    re_export_countries_with_percentage: data0.re_export_countries_with_percentage,
    no_of_full_time_employees: data0.no_of_full_time_employees,
    'top_5_customers': data0.top_5_customers,
    'top_5_suppliers': data0.top_5_suppliers,
    'banks_list': data0.banks_list,
    'shareholders':data0.shareholders,
    'is_pep':data0.is_pep
  });
}
});
}
}, [businessDatauser?.user_id, businessDatauser])

useEffect(() => {
 
  if (statusFlag === COMPLIANCE_NEW) {
    const updatedDownloads = download.map((item) => {
      const matchedDocument = getDocuments?.kyc_documents.find((doc) => {
        const trimmedDocType = doc.document_type?.replace(/\s+/g, '').trim();
        const trimmedItemType = item.doc_type?.replace(/\s+/g, '').trim();
        return trimmedItemType.includes(trimmedDocType);
      });
      
      return matchedDocument
        ? { ...item, ...matchedDocument, is_upload: true } 
        : item;
    });
    setMergedDownloads(updatedDownloads);

  } else {
    setMergedDownloads(download);
  }
},[statusFlag,getDocuments]);

 const [saveKYCBtn, setSaveKYCBtn] = useState(false)
  const[documents,setDocuments]=useState([])
 const handleSavechanges = async (data) => {
  setSaveKYCBtn(true)
  const fData = new FormData();
   
   
let documents_lst = [];
if(isDataNull)
    download.map((eachDoc) => {
      if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
        documents_lst.push({
          document_type: eachDoc.document_type,
          document_url: eachDoc.document_url,
          is_upload: !!eachDoc.document_url
        });
      }
    });

  else
  mergedDownloads.map((eachDoc) => {
    if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
      documents_lst.push({
        document_type: eachDoc.document_type,
        document_url: eachDoc.document_url,
        is_upload: !!eachDoc.document_url
      });
    }
  });
    const requiredDocuments = [
      "Valid Trade License",
      "MOA Document",
      "ID Proof - Passport/ Government Issued ID",
      "ID Proof - National ID",
      "VAT Certificate",
      "ID Proof - Address Proof",
    ];
    

    const allRequiredUploaded = requiredDocuments.every((type) => {
      const normalizedType = type.replace(/[^a-zA-Z0-9]/g, '');  
      const isUploaded = documents_lst.some((doc) => {
        const normalizedDocType = doc.document_type.replace(/[^a-zA-Z0-9]/g, '');  
        const match = normalizedType.includes(normalizedDocType) && doc.is_upload;
        return match;
      });
      return isUploaded;
    });            
    const bankStatementUploaded = documents_lst.some(
      (doc) => doc.document_type.includes("Bank Account Statement") && doc.is_upload
    );
    const mandatoryDocuments = allRequiredUploaded && bankStatementUploaded;
    for (let i = 0; i < updatedCustomers.length; i++) {
      if(updatedCustomers[i]!==undefined){
        fData.append('top_5_customers', updatedCustomers[i])};
    }
    for (let i = 0; i < updatedSuppliers.length; i++) {
      if(updatedSuppliers[i]!==undefined){fData.append('top_5_suppliers', updatedSuppliers[i])};
    }
    for (let i = 0; i < updatedBanks.length; i++) {
      if(updatedBanks[i]!==undefined){fData.append('banks_list', updatedBanks[i])}
    }
    fData.append('business_id', businessDatauser?.business_id);
    fData.append('user_id', businessDatauser?.user_id);
    fData.append('business_type', formData?.business_type);
    fData.append('phone', formData?.phone);
    fData.append('country', formData?.country);
    fData.append('sector', formData?.sector);
    fData.append('registered_address', formData?.registered_address);
    fData.append('place_of_incorporation', formData?.place_of_incorporation);
    if(formData?.date_of_incorporation){fData.append('date_of_incorporation', new Date(formData?.date_of_incorporation).getTime());} 
    fData.append('trade_license_no', formData?.trade_license_no);
    if(formData?.trade_license_expiry_date!==''){fData.append('trade_license_expiry_date',  new Date(formData?.trade_license_expiry_date).getTime());}
    fData.append('description_of_business', formData?.description_of_business);
    fData.append('beneficial_owner_with_percentage_holding', formData?.beneficial_owner_with_percentage_holding);
    fData.append('shareholders', JSON.stringify(shareHolderData));
    fData.append('products_by_the_company', formData?.products_by_the_company);
    fData.append('origin_of_products', formData?.origin_of_products);
    fData.append('import_countries_with_percentage', formData?.import_countries_with_percentage);
    fData.append('export_countries_with_percentage', formData?.export_countries_with_percentage);
    fData.append('re_export_countries_with_percentage', formData?.re_export_countries_with_percentage);
    fData.append('no_of_full_time_employees', formData?.no_of_full_time_employees);
    fData.append('is_pep', formData?.is_pep); //Yes, No
    fData.append('save_as_draft','0');
    fData.append("deleted_doc",deletedDoc);
    if (!isDataNull) {
      fData.append('business_kyc_id', businessDatauser.kyc[0]?.business_kyc_id);
    }
   
    const requiredFields = ['phone', 'sector', 'registered_address', 'place_of_incorporation', 'date_of_incorporation', 
      'trade_license_no','trade_license_expiry_date','description_of_business','beneficial_owner_with_percentage_holding',
      'products_by_the_company','origin_of_products','import_countries_with_percentage','export_countries_with_percentage',
      're_export_countries_with_percentage','no_of_full_time_employees','top_5_customers','top_5_suppliers','banks_list','shareholders','is_pep'];

      const areAllFieldsPresent = requiredFields.every((field) => {
        const value = fData.get(field);
        return value !== null && value.trim() !== ''; 
      });
// return false
    if (
      // !formData?.sector||
      //  !formData.country||
      // !formData?.registered_address||
      // !formData?.business_type||
      // !formData?.phone||
      // !formData?.is_pep
      !areAllFieldsPresent
      
    ) {
      toast.error("Please fill out mandatory fields", {
        toastId: 3,
      });
      setSaveKYCBtn(false)
    } else if(plusDisabled){
      toast.error("Please fill atleast one shareholder details", {
        toastId: 3,
      });
      setSaveKYCBtn(false)
    }else if(!mandatoryDocuments){
      toast.error("Please upload all madatory documents", {
        toastId: 5226,
      });
      setSaveKYCBtn(false)

    }
    else {
      setSaveKYCBtn(true);

      const fetchFile = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return blob;
      };
      
      documents_lst.forEach(async (elem) => {
        if (elem.document_url && elem.document_url.name) {
          const fileName = elem.document_url.name;
          const lastDotIndex = fileName.lastIndexOf('.');
          const fileExtension = fileName.substring(lastDotIndex + 1);
          fData.append(`file`, elem.document_url, elem.document_type + "." + fileExtension);
        } 
        else {
          const url = elem.document_url;
          const fileExtension = url.split('.').pop();  
      
          try {
            const fileBlob = await fetchFile(url); 
            fData.append('file', fileBlob, elem.document_type + "." + fileExtension);  
          } catch (error) {
            console.error("Error fetching file from URL:", error);
          }
        }
      });
      if(others.length!==0)
        {
          others.filter((doc) => doc && doc.name).forEach((doc) => {
            const fileName = doc?.name;
            if (fileName) {
              fData.append('file_name', fileName);
              const lastDotIndex = fileName.lastIndexOf('.');
              const fileExtension = fileName.substring(lastDotIndex + 1);
              
              fData.append('file', doc, "Others" + "." + fileExtension);
            }
          });
          
        }


      const response = await axios.post(base_url + "business-master/update_business_data", fData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
     
      if(response.data.message ==='Business KYC submitted successfully'){
        toast.success("Submitted Successfully", {
          toastId: 42,
  });
  setTimeout(() => {
    window.location.reload();
  }, 800);
}
}

  }

  const handleUpdateKyc =async ()=>{
    setSaveKYCBtn(true)
    const fData = new FormData();
    let documents_lst = [];

    download.map((eachDoc) => {
      if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
        documents_lst.push({
          document_type: eachDoc.document_type,
          document_url: eachDoc.document_url
        });
      }
    });

    for (let i = 0; i < rejectedCustomers.length; i++) {
      if(rejectedCustomers!==undefined){fData.append('top_5_customers', rejectedCustomers[i])};
    }
    for (let i = 0; i < rejectedSuppliers.length; i++) {
      if(rejectedSuppliers[i]!==undefined){fData.append('top_5_suppliers', rejectedSuppliers[i])};
    }
    for (let i = 0; i < rejectedBanks.length; i++) {
      if(rejectedBanks[i]!==undefined){fData.append('banks_list', rejectedBanks[i])}
    }
    if(others.length!==0)
      {
        others.filter((doc) => doc && doc.name).forEach((doc) => {
          const fileName = doc?.name;
          if (fileName) {
            fData.append('file_name', fileName);
            const lastDotIndex = fileName.lastIndexOf('.');
            const fileExtension = fileName.substring(lastDotIndex + 1);
            fData.append('file', doc, "Others" + "." + fileExtension);
          }
        });
        
      }
    fData.append('business_id', rejectedDetails?.business_id);
    fData.append('business_kyc_id', rejectedDetails?.business_kyc_id);
    fData.append('user_id', rejectedDetails?.user_id);
    fData.append('business_type', rejectedDetails?.business_type);
    fData.append('phone', rejectedDetails?.phone);
    fData.append('country', rejectedDetails?.country);
    fData.append('sector', rejectedDetails?.sector);
    fData.append('registered_address', rejectedDetails?.registered_address);
    fData.append('place_of_incorporation', rejectedDetails?.place_of_incorporation);
    if(rejectedDetails?.date_of_incorporation){
    fData.append('date_of_incorporation', new Date(rejectedDetails?.date_of_incorporation).getTime());} 
    fData.append('trade_license_no', rejectedDetails?.trade_license_no);
    if(rejectedDetails?.trade_license_expiry_date!==''){
    fData.append('trade_license_expiry_date',  new Date(rejectedDetails?.trade_license_expiry_date).getTime());}
    fData.append('description_of_business', rejectedDetails?.description_of_business);
    fData.append('beneficial_owner_with_percentage_holding', rejectedDetails?.beneficial_owner_with_percentage_holding);
    fData.append('shareholders', JSON.stringify(rejectedShareHolderData));
    fData.append('products_by_the_company', rejectedDetails?.products_by_the_company);
    fData.append('origin_of_products', rejectedDetails?.origin_of_products);
    fData.append('import_countries_with_percentage', rejectedDetails?.import_countries_with_percentage);
    fData.append('export_countries_with_percentage', rejectedDetails?.export_countries_with_percentage);
    fData.append('re_export_countries_with_percentage', rejectedDetails?.re_export_countries_with_percentage);
    fData.append('no_of_full_time_employees', rejectedDetails?.no_of_full_time_employees);
    fData.append('is_pep', rejectedDetails?.is_pep); //Yes, No
    fData.append("deleted_doc",deletedDoc);
    fData.append('status',statusFlag)
    fData.append('save_as_draft','0');

    const requiredFields = ['phone', 'sector', 'registered_address', 'place_of_incorporation', 'date_of_incorporation', 
      'trade_license_no','trade_license_expiry_date','description_of_business','beneficial_owner_with_percentage_holding',
      'products_by_the_company','origin_of_products','import_countries_with_percentage','export_countries_with_percentage',
      're_export_countries_with_percentage','no_of_full_time_employees','top_5_customers','top_5_suppliers','banks_list','shareholders','is_pep'];

      const areAllFieldsPresent = requiredFields.every((field) => {
        const value = fData.get(field);
        return value !== null && value.trim() !== ''; 
      });

      if (!areAllFieldsPresent) {
        toast.error("Please fill all the required fields", {
          toastId: 422,
        });
        setSaveKYCBtn(false)
        return;
      } 
      else {
   
      documents_lst.forEach(elem => {
        if (elem.document_url) {
          const fileName = elem.document_url.name;
          const lastDotIndex = fileName.lastIndexOf('.');
          const fileExtension = fileName.substring(lastDotIndex + 1);
          fData.append('file', elem.document_url,elem.document_type + "." + fileExtension);
          if (elem.document_type === "Others") {
            fData.append('file_name', fileName);
          }
        }
      })

      const response = await axios.post(base_url + "business-master/update_business_kyc", fData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
 
      if(response.data.message ==='Updated Business Master/KYC'){
  toast.success("Updated Successfully", {
    toastId: 42,
  });
  setTimeout(() => {
    window.location.reload();
  }, 800);
}else{
setSaveKYCBtn(false)
alert("Something went wrong")

}
}
  }
  const handleSaveDraft = async () => {
    setSaveKYCBtn(true);
    const fData = new FormData();
    
    for (let i = 0; i < updatedCustomers.length; i++) {
      if(updatedCustomers[i]) {
        fData.append('top_5_customers', updatedCustomers[i]);
      }
    }
    
    for (let i = 0; i < updatedSuppliers.length; i++) {
      if(updatedSuppliers[i]) {
        fData.append('top_5_suppliers', updatedSuppliers[i]);
      }
    }
    
    for (let i = 0; i < updatedBanks.length; i++) {
      if(updatedBanks[i]) {
        fData.append('banks_list', updatedBanks[i]);
      }
    }
    let documents_lst = [];
    download.map((eachDoc) => {
      if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
        documents_lst.push({
          document_type: eachDoc.document_type,
          document_url: eachDoc.document_url,
          is_upload: !!eachDoc.document_url
        });
      }
    });
    documents_lst.forEach(elem => {
      if (elem.document_url.name) {
        const fileName = elem.document_url.name;
        const lastDotIndex = fileName.lastIndexOf('.');
        const fileExtension = fileName.substring(lastDotIndex + 1);
        fData.append('file', elem.document_url, elem.document_type + "." + fileExtension);
      }
      
    })

    if(others.length!==0)
      {
        others.filter((doc) => doc && doc.name).forEach((doc) => {
          const fileName = doc?.name;
          if (fileName) {
            fData.append('file_name', fileName);
            const lastDotIndex = fileName.lastIndexOf('.');
            const fileExtension = fileName.substring(lastDotIndex + 1);
            fData.append('file', doc, "Others" + "." + fileExtension);
          }
        });
        
      }
    fData.append('business_id', businessDatauser?.business_id);
    fData.append('user_id', businessDatauser?.user_id);
    fData.append('business_type', formData?.business_type || '');
    fData.append('phone', formData?.phone || '');
    fData.append('country', formData?.country || '');
    fData.append('sector', formData?.sector || '');
    fData.append('registered_address', formData?.registered_address || '');
    fData.append('place_of_incorporation', formData?.place_of_incorporation || '');
    if(formData?.date_of_incorporation) {
      fData.append('date_of_incorporation', new Date(formData?.date_of_incorporation).getTime());
    }
    fData.append('trade_license_no', formData?.trade_license_no || '');
    if(formData?.trade_license_expiry_date) {
      fData.append('trade_license_expiry_date', new Date(formData?.trade_license_expiry_date).getTime());
    }
    fData.append('description_of_business', formData?.description_of_business || '');
    fData.append('beneficial_owner_with_percentage_holding', formData?.beneficial_owner_with_percentage_holding || '');
    fData.append('shareholders', JSON.stringify(shareHolderData || []));
    fData.append('products_by_the_company', formData?.products_by_the_company || '');
    fData.append('origin_of_products', formData?.origin_of_products || '');
    fData.append('import_countries_with_percentage', formData?.import_countries_with_percentage || '');
    fData.append('export_countries_with_percentage', formData?.export_countries_with_percentage || '');
    fData.append('re_export_countries_with_percentage', formData?.re_export_countries_with_percentage || '');
    fData.append('no_of_full_time_employees', formData?.no_of_full_time_employees || '');
    fData.append('is_pep', formData?.is_pep || '');
    if (Array.isArray(getDocuments?.kyc_documents) && getDocuments.kyc_documents.length > 0) {
      getDocuments.kyc_documents.forEach((doc, index) => {
        if (doc?.document_url) {
         documents.push(doc.document_url);
        }
      });
    }
     fData.append("deleted_doc",deletedDoc);
    if (!isDataNull) {
      fData.append('business_kyc_id', businessDatauser.kyc[0]?.business_kyc_id);
    }
    fData.append('save_as_draft', '1');
    fData.append('status', statusFlag);
    try {
      const response = await axios.post(
        base_url + "business-master/save_business_data", 
        fData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
  
      if(response.data.message === 'Draft saved successfully') {
        toast.success("Draft saved successfully", {
          toastId: 40,
        });
      }
    } catch (error) {
      toast.error("Failed to save draft", {
        toastId: 41,
      }); 
    }
    finally{
      setSaveKYCBtn(false);
      setTimeout(()=>{
      window.location.reload();
      },200)    }
  };
  return (
    <div style={{ display: "flex" }}>
      <SideNavBar status={businessDatauser?.onboard_status}/>
      <main style={{ width: "100%" }}>
        <NavBarMain />
        <div className="pt-3 pb-0 p-4 pagestyle">
          <div className=" d-flex  align-items-center ">
            <h1 className="mb-0">KYC FORM</h1>
          </div>

          <div className="settingsmaindiv">
            <div className="">
              <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
                <li className="nav-item-indiv-busns" role="presentation">
                  <button
                    className="nav-link-inv active p-1"
                    id="BasicDetails-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#BasicDetails-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="BasicDetails-tab-pane"
                    aria-selected="true"
                  >
                    <h3>Form Details</h3>
                  </button>
                  {businessDatauser?.kyc?.length=== 0 && <span className="text-danger fs-6">Status: Please fill the KYC Form </span>}
                  {businessDatauser?.kyc?.length>0 && businessDatauser?.kyc[0]?.status === COMPLIANCE_PENDING && <span className="text-danger fs-6">Status: Under Review</span>}
                  {businessDatauser?.kyc?.length>0 && businessDatauser?.kyc[0]?.status=== COMPLIANCE_REJECTED && <span className="text-danger fs-6">Status: Rejected</span>}
                  {businessDatauser?.kyc?.length>0 && businessDatauser?.kyc[0]?.status=== COMPLIANCE_APPROVED && <span className="text-danger fs-6">{businessDatauser?.kyc[0]?.kyc_expiry_date < new Date().getTime() ? "KYC expired on": "KYC Expiry Date"} : {moment(businessDatauser?.kyc[0]?.kyc_expiry_date).format("DD-MMM-YYYY")}{(businessDatauser?.kyc[0]?.kyc_expiry_date) < (new Date().getTime()) ? ". Please fill the KYC form":""}</span>}
                </li>
              </ul>
            </div>
            <div className="tab-content " id="myTabContent">
              <div
                className="tab-pane fade show active "
                id="BasicDetails-tab-pane"
                role="tabpanel"
                aria-labelledby="BasicDetails-tab"
                tabIndex="0"
              >
              <BusinessSettings 
              rejectedShareHolderData={rejectedShareHolderData}
              handleAddRow={handleAddRow}
              handleInputChange={handleInputChange}
               shareHolderData={shareHolderData}
               masterData={masterBusinessData}
               dataUser={businessDatauser}
               defaultvalue={defaultvalue}
               handleRemoveRow={handleRemoveRow}
               statusFlag={statusFlag}
               handleFieldChange={handleFieldChange}
               rejectedDetails={rejectedDetails}
               formData={formData}
               rejectedFlag={rejectedFlag}
               rejectedCustomers={rejectedCustomers}
               getDocuments={getDocuments}
               updatedCustomers={updatedCustomers}
               handleCustomerChange={handleCustomerChange}
               rejectedSuppliers={rejectedSuppliers}
               handleSupplierChange={handleSupplierChange}
               updatedSuppliers={updatedSuppliers}
               rejectedBanks={rejectedBanks}
               handleBankChange={handleBankChange}
               updatedBanks={updatedBanks}
               download={download}
               handleChange={handleChange}
               handleChangeDownload={handleChangeDownload}
               saveKYCBtn={saveKYCBtn}
               handleSubmit={handleSubmit}
               handleSavechanges={handleSavechanges}
               handleUpdateKyc={handleUpdateKyc}
               handleDeleteClick={handleDeleteClick}
               handleSaveDraft={handleSaveDraft}
               mergedDownloads={mergedDownloads}
               handleIsDataNull={isDataNull}
               handleChangeDownloadForOthers={handleChangeDownloadForOthers}
               others={others}
               handleDeleteClickOthers={handleDeleteClickOthers}
              />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Kycform;


// export const InputFieldKYC =({min,max, htmlFor,label,type,divClass, id, value,name, placeholder, mandatory, onChange, disabled})=>{
//   return(
//     <div className={divClass? divClass : "col-lg"}>
//     <form className="form-group col mt-0 custm_input_styl_stngs disabledstyle">
//       <label htmlFor={htmlFor}>
//         <p> {label}<span style={{ color: "red" }}>{mandatory}</span> </p>
//       </label>
//       <input
//         disabled={disabled}
//         max={max}
//         min={min}
//         type={type?type:"text"}
//         name={name}
//         id={id}
//         className="form-control bg-white"
//         placeholder={placeholder}
//         value={value}
//         onChange={onChange}
//       />
//     </form>
//   </div>
//   )
// }

export const InputFieldKYC = ({
  min,
  max,
  htmlFor,
  label,
  type,
  divClass,
  id,
  value,
  name,
  placeholder,
  mandatory,
  onChange,
  disabled,
  error,
  readOnly,
  onKeyDown,
  helperText
}) => {
  return (
    <div className={divClass ? divClass : "col-lg"}>
      <form className="form-group col mt-0 custm_input_styl_stngs disabledstyle">
        <label htmlFor={htmlFor} >
          {label}
          {mandatory && <span  style={{ color: "red" }}> {mandatory}</span>}
        </label>

        <input
          disabled={disabled}
          max={max}
          min={min}
          type={type ? type : "text"}
          name={name}
          id={id}
          // className="form-control bg-white"
            className={`form-control bg-white ${error ? "input-error" : ""}`}

          placeholder={placeholder}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          onKeyDown={onKeyDown}
          helperText={helperText}
        />
      </form>
    </div>
  );
};



export const TextAreaField=({className,textareaClassName, mandate,label,disabled, value, onChange,row,placeholder,name, id})=>{
  return(
    <form className={`${className} form-group col me-1 custm_input_styl_stngs aksjdhf`}>
                      <label htmlFor="typeofbusns">
                        <p>{label}{mandate && <span>{mandate}</span>} </p>
                      </label>
                      <textarea
                        name={name}
                        id={id}
                        className={`${textareaClassName} form-control bg-white`}
                        placeholder={placeholder}
                        disabled={disabled}
                        rows={row}
                        value={value}
                        onChange={onChange}
                      />
                    </form>
  )
}